import PropTypes from 'prop-types';
import React from 'react';

import ToggleButtonRadio from '../../Molecules/ToggleButtonRadio/ToggleButtonRadio';

const PortEnableDisableBtn = ({ id }) => {
  return (
    <ToggleButtonRadio
      name={`${id}_status`}
      valuesAsBoolean
      groupClassName="mb-0"
      size="sm"
    >
      <ToggleButtonRadio.Option value>ON</ToggleButtonRadio.Option>
      <ToggleButtonRadio.Option value={false}>OFF</ToggleButtonRadio.Option>
    </ToggleButtonRadio>
  );
};

PortEnableDisableBtn.propTypes = {
  id: PropTypes.string.isRequired,
};

export default PortEnableDisableBtn;
